import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

/**
 * Invalidate the guest share-link queries for workplace requests.
 * Use after creating or revoking a share link so the link list refetches.
 */
export const useInvalidateWorkplaceRequestShareLinks = () => {
  const queryClient = useQueryClient();

  return useCallback(async () => {
    await queryClient.invalidateQueries({
      queryKey: ["workplaceRequestShareLinks"]
    });
  }, [queryClient]);
};
